var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import xssFilters from 'xss-filters';
import { Image } from '../image';
import { Text } from '../text';

var Link = function (_super) {
  __extends(Link, _super);

  function Link() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Link.prototype.render = function () {
    var _a = this.props,
        style = _a.style,
        url = _a.url,
        imageurl = _a.imageurl,
        text = _a.text,
        imgStyle = _a.imgStyle,
        className = _a.className,
        disabled = _a.disabled,
        onClick = _a.onClick;
    var sanitizedUrl = xssFilters.uriInDoubleQuotedAttr(url);
    var props = {
      href: sanitizedUrl,
      style: style,
      className: className,
      disabled: disabled,
      onClick: onClick
    }; // 根据当前是否有imageurl来判断当前的超链接为文本OR图片

    return imageurl ? React.createElement("a", __assign({}, props), React.createElement(Image, {
      imageurl: imageurl,
      style: imgStyle
    })) : React.createElement("a", __assign({}, props), React.createElement(Text, {
      text: text || ''
    }));
  };

  return Link;
}(PureComponent);

export { Link };